import { render, staticRenderFns } from "./nbGeomagnetism.vue?vue&type=template&id=db14cd62&scoped=true"
import script from "./nbGeomagnetism.vue?vue&type=script&lang=js"
export * from "./nbGeomagnetism.vue?vue&type=script&lang=js"
import style0 from "./nbGeomagnetism.vue?vue&type=style&index=0&id=db14cd62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db14cd62",
  null
  
)

export default component.exports